import { useEffect } from 'react';
import { useBoolean } from 'usehooks-ts';
import HeightAnimation from '@/animations/height';
import Dialog from '@/components/dialog';
import Quiz from '@/components/quiz';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { SliderSlice } from '@/redux/slider';
import { GeneralSlice } from '@/redux/general';
import MouseFlow from '@/utils/mouse-flow';
import { hideContent } from '@/utils/utils';
import '@/components/succes-text/success-text-v2.css';
import '@/components/succes-text/success-text-v1.css';

// TODO: use isFormSubmissionFailed selectors

export default function SuccessText() {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const dialog = useAppSelector(ConfigSlice.selectors.additionalQuestions);
  const { success, failure } = useAppSelector(ConfigSlice.selectors.resultPage);
  const isFormSubmissionSuccessful = useAppSelector(SliderSlice.selectors.isFormSubmissionSuccessful);
  const isFormSubmissionFailed = useAppSelector(SliderSlice.selectors.isFormSubmissionFailed);
  const isBrazeProspect = useAppSelector(GeneralSlice.selectors.brazeProspect);
  const { value: isQuizOpen, setTrue: openQuiz, setFalse: closeQuiz } = useBoolean(false);

  useEffect(() => {
    hideContent('seo');
    MouseFlow.push('newPageView', '/standard-thanks-page');
  }, []);

  useEffect(() => {
    if (!dialog?.show || isBrazeProspect) return;
    const timer = setTimeout(openQuiz, 0);
    return () => clearTimeout(timer);
  }, [dialog, isBrazeProspect]);

  return (
    <div data-css-version={cssVersion} className='success-text'>
      <HeightAnimation on={isFormSubmissionSuccessful}>
        <div className='success-text__content success-text__content--success'>
          {cssVersion === 2 && <div className='success-text__emoji'>🎉</div>}
          {success()}
        </div>
      </HeightAnimation>
      <HeightAnimation on={isFormSubmissionFailed}>
        <div className='success-text__content success-text__content--failure'>{failure()}</div>
      </HeightAnimation>
      <Dialog on={isQuizOpen} size='2/3' position='center' heightMax='70' onClose={closeQuiz}>
        <Quiz onCompleteQuiz={closeQuiz} />
      </Dialog>
    </div>
  );
}
